import { Slider } from 'components/molecules/Slider'
import { Card } from 'components/organisms/Card'
import { Section } from 'components/organisms/Section'
import type { WhyUsProps } from './types'
import { cn } from 'lib/utils'

import './index.scss'

const mainClass = 'why-us'

export const WhyUs = ({
  title,
  subtitle,
  note,
  action,
  list = [],
  modifier = 'card--secondary',
}: WhyUsProps) => {
  const shouldHideArrows = list.length <= 4

  if (!list.length) {
    return null
  }

  return (
    <Section
      id="_whyus"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      <Slider
        variableWidth
        className={cn(
          `${mainClass}__slider`,
          shouldHideArrows && `${mainClass}__slider--no-arrows`
        )}
      >
        {list.map((item) => (
          <Card
            key={item.id}
            title={item.title}
            text={item.text}
            image={item.image}
            modifier={modifier}
          />
        ))}
      </Slider>
    </Section>
  )
}
